<template lang="pug">
  .ride-union-container
    .ride-left
      RideMonthTemplateUnion(
        :type="isEbike() ? 'ebike' : 'ride'"
        :title="isEbike()?'助力车月卡':'单车月卡'"
        :status="rideStatue===0?RideCardStatusEnum.RECEIVABLE:RideCardStatusEnum.WAIT_FOR_RECEIVE"
        :totalCardDays="totalCardDays"
        :totalCardTimes="totalCardTimes"
        :cityNames="cityNames"
        :rideFreeMinute="rideFreeMinute"
        :rideDays="rideDays"
        :cardsStatus="status"
        :rideTimes="rideTimes"
        :isOpen="true"
        :showRideCardTouting="showRideCardTouting"
        :rideStatue="rideStatue"
        :rideCardInfoValue="rideCardInfoValue"
        :isLotteryNew="isLotteryNew"
        @goUse="goUse"
      )
        .button-wait-receive(v-if="showRideCardTouting" :class="isEbike() ? 'ebike' : 'ride'")
          .text(@click="pickCoupon") 领取
    .union-right
      UnionCard(:unionData="unionData" @refreshData="handleRefresh")
</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import {
  submitTired,
} from '@/api/vip';
import {
  getTokenAndKey,
  safeGet,
} from '@/utils';
import { Toast } from 'vant';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { PropVersionMap, RideCardStatusEnum } from '@/const/vip';
import { RIDE_CARD_STATUS } from '../../consts';
import RideMonthTemplateUnion from './ride-month-template-union.vue';
import UnionCard from './union-card.vue';


const rideTipsEnum = {
  notEnable: {
    text: '你有骑行卡生效中，已发放的',
    highlight: '全国卡可按需手动启用',
  },
  notEnableIncludeAc: {
    text: '全国卡生效中，已发卡将在当前卡失效后自动启用',
    highlight: null,
  },
};


export default {
  components: {
    RideMonthTemplateUnion,
    UnionCard,
  },
  props: {
    groups: {
      type: Object,
      default: null,
    },
    propVersion: {
      type: String,
      default: '',
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    unionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rideStatue: null,
      rideDays: null,
      rideTimes: null,
      status: null, // 领取状态
      env,
      totalCardDays: null, // 天
      totalCardTimes: null, // 次
      cityNames: null,
      rideFreeMinute: null, // 时间
      cardMap: RIDE_CARD_STATUS,
      showRideCard: true,
      rideTipsShow: false,
      rideTips: null,
      showRideCardTouting: false,
      rideCardInfoValue: false,
      RideCardStatusEnum,
    };
  },
  computed: {
    showAppUseBar() {
      return (env.isAliMP || env.isAliMPMonitor || env.isAlipayBrowser)
        && this.propVersion
        && [PropVersionMap.RIDE_APP, PropVersionMap.LADDER_APP, PropVersionMap.RIDE_EBIKE_APP].includes(this.propVersion);
    },
  },
  watch: {
    // watch groups
    groups() {
      this.init();
    },

  },
  mounted() {
    this.init();
  },
  methods: {
    isEbike() {
      if (this.propVersion) {
        return this.propVersion.includes('ebike');
      }
      return false;
    },
    goUse() {
      if (this.showRideCardTouting) {
        this.pickCoupon();
      } else if (this.groups && this.groups.coupons && Array.isArray(this.groups.coupons)) {
        this.$emit('useRide', this.groups.coupons[0]);
      }
    },
    goUrl() {
      this.$emit('gourl');
    },
    goMycard() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''
        }latest/index.html#/my-cards?adsource=`;
      }
    },
    pickCoupon() {
      const coupon = safeGet(this, 'groups.propList.0');
      this.$emit('click-btn', { ...(coupon || {}), showLadderCoupon: false });

      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_card_button',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async closeRideTips() {
      try {
        const { token } = await getTokenAndKey();
        const { code, msg } = await submitTired({
          scene: 'rideCardEnableTips',
          token,
        }) || {};
        if (code !== 0) {
          Toast.show(msg);
        }
        this.rideTipsShow = false;
        this.clickRideTipsButton();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    init() {
      if (this.groups && this.groups.propList) {
        this.showRideCardTouting = safeGet(this, 'groups.propList.0.status') === 1;
        if (this.groups.propList[0].rideCardInfo) {
          this.rideCardInfoValue = true;
          this.rideDays = this.groups.propList[0].rideCardInfo.remainDays;
          this.rideTimes = this.groups.propList[0].rideCardInfo.useProperty.remainCardTimes;
          this.rideStatue = this.groups.propList[0].rideCardInfo.status;
          this.totalCardDays = this.groups.propList[0].rideCardInfo.useProperty.totalCardDays;
          this.totalCardTimes = this.groups.propList[0].rideCardInfo.useProperty.totalCardTimes;
          const tipsType = safeGet(this, 'groups.propList.0.rideCardInfo.tipsType');
          this.rideTipsShow = Object.keys(rideTipsEnum).includes(tipsType);
          this.rideTips = rideTipsEnum[tipsType];

          if (this.groups.propList[0].rideCardInfo
            && this.groups.propList[0].rideCardInfo.useRuleProperty
            && Array.isArray(this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames)) {
            if (this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames.length > 0) {
              if (this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames.length > 1) {
                this.cityNames = `限${this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames[0]}...`;
              } else {
                // eslint-disable-next-line prefer-destructuring
                this.cityNames = `限${this.groups.propList[0].rideCardInfo.useRuleProperty.cityNames[0]}`;
              }
            } else {
              this.cityNames = '全国通用';
            }
          } else {
            this.cityNames = '全国通用';
          }
          if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 1) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideFreeMinute}分钟`;
          } else if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 2) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideDiscount}折`;
          } else if (this.groups.propList[0].rideCardInfo.deductRule.reduceType === 0) {
            this.rideFreeMinute = `${this.groups.propList[0].rideCardInfo.deductRule.rideFreeCost}元`;
          } else {
            this.rideFreeMinute = '-';
          }
        } else if (!this.propVersion.includes('ebike')) {
          this.showRideCard = false;
        } else {
          this.showRideCard = true;
          this.rideCardInfoValue = false;
        }
      }
      if (this.groups && this.groups.coupons && Array.isArray(this.groups.coupons)) {
        this.status = this.groups.coupons[0].status;
      }


      if (this.rideTipsShow) {
        this.rideTipsExpose();
      }

      if (this.showRideCardTouting) {
        this.exposeRideCardTouting();
      }
    },

    rideTipsExpose() {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_cards_remind',
        contentId: 'platform_cards_remind',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    clickRideTipsButton() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_cards_remind',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    exposeRideCardTouting() {
      UBT.moduleExpose({
        pageId: 'platform_openedcard_page',
        categoryId: 'platform',
        moduleId: 'platform_card_button',
        contentId: 'platform_card_button',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    handleRefresh() {
      this.$emit('refreshData');
    },
  },
};
</script>
<style lang="less" scoped>
.ride-union-container {
  margin: 0.1rem 0.12rem 0.08rem 0.12rem;
  border-radius: 0.16rem;
  position: relative;
  display: flex;
  overflow: hidden;

  .common-card {
    padding: 0.12rem;
    max-width: 1.71rem;
    flex: 1;
    background-color: #fff;
    border-radius: 0.16rem;
    height: 1.27rem;
  }

  .ride-left {
    .common-card();

    margin-right: 0.09rem;

    .button-wait-receive{
      position:absolute;
      bottom:0.12rem;
      min-width:0.6rem;
      background-color:#fff;
      display: flex;
      align-items: center;
      height:0.22rem;
      border-radius:0.06rem;
      padding:0.035rem 0.055rem 0.035rem 0.055rem;
      margin-left:0.12rem;
      position: absolute;
      bottom: 0.12rem;
      left:0;
      justify-content: center;

      .text {
        font-weight: 500;
        font-size: 0.12rem;
        line-height: 100%;
        color: rgba(0, 0, 0, 1);
      }
    }
  }

  .union-right {
    .common-card();
  }
}
</style>
